import React from "react";
import { FileText, Scale } from "lucide-react";

const BADGE_CONFIG = {
  OFICIO_EXPEDIDO: {
    label: "Ofício expedido",
    title: "Kortex confirmou expedição/transmissão de ofício requisitório",
    className: "bg-teal-100 text-teal-800 border-teal-200",
    Icon: FileText,
  },
  DIREITO_CREDITORIO: {
    label: "Direito creditório",
    title: "Crédito em fase de direito creditório (sem ofício expedido confirmado)",
    className: "bg-indigo-100 text-indigo-800 border-indigo-200",
    Icon: Scale,
  },
};

export default function CreditProductBadge({ tipoProduto, className = "" }) {
  const config = BADGE_CONFIG[tipoProduto] || BADGE_CONFIG.DIREITO_CREDITORIO;
  const { label, title, className: badgeClassName, Icon } = config;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-semibold border ${badgeClassName} ${className}`}
      title={title}
    >
      <Icon className="w-3.5 h-3.5 flex-shrink-0" />
      {label}
    </span>
  );
}
